// eslint-disable-next-line unicorn/prefer-node-protocol
import { Buffer } from 'buffer'

global.Buffer = Buffer
